import React from 'react';
import UserAvatar from 'components/pure/utils/UserAvatar';
import './AssumedUserBadge.styl';

export default class AssumedUserBadge extends React.Component {
  render() {
    const {user, type} = this.props;
    return (
      <div className="assumed-user-badge">
        <UserAvatar user={user} />
        <div className="name-col">
          <div className={'user-name ' + type}>{user.getDisplayName()}</div>
          <div className="type">
            {type === 'manager' ? 'Manager' : type === 'coach' ? 'Coach' : 'Rep'}
          </div>
        </div>
      </div>
    );
  }
}
